import { render, staticRenderFns } from "./ManualCallsOptions.vue?vue&type=template&id=bd81ac2a&scoped=true"
import script from "./ManualCallsOptions.vue?vue&type=script&lang=js"
export * from "./ManualCallsOptions.vue?vue&type=script&lang=js"
import style0 from "./ManualCallsOptions.vue?vue&type=style&index=0&id=bd81ac2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81ac2a",
  null
  
)

export default component.exports